// extracted by mini-css-extract-plugin
export default {"game":"Game_game__VuqWx","button":"Game_button__Sp22Z","shadow":"Game_shadow__Rjo-o"};